import { useEffect, useState } from "react";
import { ConstantRoutes } from "../../../core/constantRoutes";
import { useFaqStore } from "../../../stores/faqStore";
import FaqItem from "./faqItem";
import { useTranslation } from "react-i18next";
import FaqSkeleton from "./faqSkeleton";

const Faq: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLanguageCode = i18n.language;
  const { faq, fetchFaq } = useFaqStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchFaq();
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, []);

  const faqForCurrentLanguage = faq.find((f) => f.lang === currentLanguageCode);

  return (
    <>
      <div className="flex flex-col z-10" id={ConstantRoutes.faq}>
        <div className="max-w-screen-2xl w-full place-self-center text-center pb-10 md:pt-40 max-md:pt-10">
          <h1 className="text-4xl font-bold pb-6">FAQ</h1>

          {isLoading ? (
            <FaqSkeleton itemsCount={5} />
          ) : faqForCurrentLanguage ? (
            <div className="max-md:p-4">
              {faqForCurrentLanguage.records.map((record, index) => (
                <FaqItem
                  key={index}
                  header={record.header}
                  fullText={record.description}
                />
              ))}
            </div>
          ) : (
            <p>NO FAQs</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Faq;